@if (user) {
    <app-blade-header [bladeIndex]="bladeIndex">
        <ng-container title>
            <span class="text-small blade-title">{{
                'Register Damage Risk' | translate
            }}</span>
        </ng-container>
    </app-blade-header>
    <ng-container>
        <form
            class="form"
            [formGroup]="registerDamageRiskObject"
            (ngSubmit)="onSubmit()"
        >
            <div class="large-properties highlight-background">
                <div class="property">
                    <div class="label">
                        <i class="fa-solid fa-clock"></i>
                        {{ 'Created Date' | translate }}
                    </div>
                    <div class="value">
                        {{
                            registerDamageRiskObject.get('createdDate').value
                                | date: 'yyyy-MM-dd'
                        }}
                    </div>
                </div>
                <div class="property">
                    <div class="label">
                        <i class="fa-solid fa-user"></i>
                        {{ 'Created by' | translate }}
                    </div>
                    <div class="value">
                        {{ user?.userid ? user?.userid : '' }}
                    </div>
                </div>
            </div>
            <mat-divider class="mat-divider-horizontal divider-1"></mat-divider>
            <div class="large-properties highlight-background">
                <div class="property">
                    <div class="title">{{ 'Details' | translate }}</div>
                </div>
            </div>
            <div class="large-properties highlight-background">
                <div class="property">
                    <div class="label">
                        <i class="fa-solid fa-location-dot"></i>
                        {{ 'Position' | translate }}
                    </div>
                    <div class="value">{{ latitude }}, {{ longitude }}</div>
                </div>
                <div class="property">
                    <div class="label">{{ 'Status' | translate }}</div>
                    <div class="value">
                        {{ registerDamageRiskObject.get('status').value }}
                    </div>
                </div>
            </div>
            <div>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Observed by' | translate }}</mat-label>
                    <input
                        matInput
                        formControlName="observedBy"
                        #observedByInput
                    />
                    @if (
                        registerDamageRiskObject
                            .get('observedBy')
                            .hasError('required')
                    ) {
                        <mat-error>
                            {{ 'Required' | translate }}
                        </mat-error>
                    }
                    @if (
                        registerDamageRiskObject
                            .get('observedBy')
                            .hasError('maxlength')
                    ) {
                        <mat-error>
                            {{ 'Cannot exceed 50 characters' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <div class="d-flex">
                    <div class="flex-grow-1 mw-50">
                        <mat-form-field appearance="fill">
                            <mat-label>{{
                                'Observed Date' | translate
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="observedDate"
                                type="date"
                                [max]="maxDate"
                            />
                            @if (
                                registerDamageRiskObject
                                    .get('observedDate')
                                    .hasError('required')
                            ) {
                                <mat-error>
                                    {{ 'Required' | translate }}
                                </mat-error>
                            }
                            <!-- <mat-error *ngIf="registerDamageRiskObject.hasError('observedDateTimeError')">
              {{ 'Date must be in the past' | translate }}
            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="flex-grow-1 mw-50">
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'Time' | translate }}</mat-label>
                            <input
                                matInput
                                formControlName="observedTime"
                                type="time"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Address' | translate }}</mat-label>
                    <input matInput formControlName="address" />
                    @if (
                        registerDamageRiskObject
                            .get('address')
                            .hasError('maxlength')
                    ) {
                        <mat-error>
                            {{ 'Cannot exceed 100 characters' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'City' | translate }}</mat-label>
                    <input matInput formControlName="city" />
                    @if (
                        registerDamageRiskObject
                            .get('city')
                            .hasError('maxlength')
                    ) {
                        <mat-error>
                            {{ 'Cannot exceed 50 characters' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Route' | translate }}</mat-label>
                    <input matInput formControlName="route" />
                    @if (
                        registerDamageRiskObject
                            .get('route')
                            .hasError('maxlength')
                    ) {
                        <mat-error>
                            {{ 'Cannot exceed 20 characters' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Trafficarea' | translate }}</mat-label>
                    <mat-select
                        formControlName="trafficAreaId"
                        (selectionChange)="onTrafficAreaChange($event)"
                    >
                        @for (area of trafficAreaData; track area) {
                            <mat-option [value]="area.id">
                                {{ area.name }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (
                        registerDamageRiskObject
                            .get('trafficAreaId')
                            .hasError('required')
                    ) {
                        <mat-error>
                            {{ 'Required' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Description' | translate }}</mat-label>
                    <textarea
                        matInput
                        placeholder="Description"
                        formControlName="description"
                    ></textarea>
                    @if (
                        registerDamageRiskObject
                            .get('description')
                            .hasError('required')
                    ) {
                        <mat-error>
                            {{ 'Required' | translate }}
                        </mat-error>
                    }
                    @if (
                        registerDamageRiskObject
                            .get('description')
                            .hasError('maxlength')
                    ) {
                        <mat-error>
                            {{ 'Cannot exceed 500 characters' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <div class="d-flex">
                    <button
                        mat-flat-button
                        class="secondary-button ml-3"
                        type="button"
                        [disabled]="isProcessing"
                        (click)="reset($event)"
                    >
                        {{ 'Clear' | translate }}
                    </button>
                    <button
                        mat-flat-button
                        class="primary-button ml-3"
                        type="submit"
                        [disabled]="isProcessing"
                    >
                        {{ 'Register' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </ng-container>
}
